import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './store/store';
import { AppThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout/Layout';
import AuthProvider from './components/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';
import { StripeProvider } from './contexts/FirebaseStripeContext';
import LandingPage from './pages/LandingPage';
import NewLandingPage from './pages/NewLandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SettingsPage from './pages/SettingsPage';
import LeaseForm from './components/LeaseForm/LeaseForm';
import NotificationSnackbar from './components/NotificationSnackbar';
import TermsPage from './pages/TermsPage';
import { initializeClarity, trackPageView } from './services/clarityService';
import './styles/coinbase-theme.css';

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // Initialize Clarity analytics
      initializeClarity();
      // Track initial page view
      trackPageView('landing-page');
    }
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <AppThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <StripeProvider>
                <Router>
                <Layout>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/new" element={<NewLandingPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/dashboard" element={
                      <ProtectedRoute>
                        <DashboardPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/settings" element={
                      <ProtectedRoute>
                        <SettingsPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/create-lease" element={
                      <ProtectedRoute>
                        <LeaseForm />
                      </ProtectedRoute>
                    } />
                    <Route path="/create-lease/:leaseId" element={
                      <ProtectedRoute>
                        <LeaseForm />
                      </ProtectedRoute>
                    } />
                  </Routes>
                </Layout>
              </Router>
          </StripeProvider>
        </AuthProvider>
        <NotificationSnackbar />
      </AppThemeProvider>
    </Provider>
  </HelmetProvider>
  );
}

export default App; 
